import React from "react";
import PropTypes from "prop-types";
import { useAppInstallModal } from "../../../store/useAppInstallModal";
import { openAppAndAction } from "../../../util/util";

function CollectionWishlist({ name }) {
    const { openModal } = useAppInstallModal();

    const handleOpenWishlist = () => {
        const message = `앱에서 ${name}의\n위시리스트를 확인해보세요!`;
        openAppAndAction(() => openModal(message), null, 1000);
    };

    return (
        <section className="CollectionCortisWishlist">
            <div className="CollectionCortisWishlist-header">
                <h3 className="CollectionCortisWishlist-title">{name}의 위시리스트</h3>
            </div>
            <div className="CollectionCortisWishlist-placeholder">
                <button type="button" onClick={handleOpenWishlist} className="CollectionCortis-shareButton">
                    위시리스트 보러가기
                </button>
            </div>
        </section>
    );
}

CollectionWishlist.propTypes = {
    name: PropTypes.string.isRequired,
};

export default React.memo(CollectionWishlist);
